import { combineReducers } from "redux";
import aboutUsReducer from "./aboutUsReducer";
import authReducer from "./authReducer";
import changepasswordReducer from "./changepasswordReducer";
import ContactUsReducer from "./ContactUsReducer";
import faqReducer from "./faqReducer";
import favouriteReducer from "./favouriteReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import homeReducer from "./homeReducer";
import landingPageReducer from "./landingPageReducer";
import profileReducer from "./profileReducer";
import choiceReducer from "./choiceReducer";
import termsConditionReducer from "./termsConditionReducer";
import privacyPolicyReducer from "./privacyPolicyReducer";


export default combineReducers({
  auth: authReducer,
  userProfile: profileReducer,
  faqInfo: faqReducer,
  aboutUsInfo: aboutUsReducer,
  contactUsInfo:ContactUsReducer,
  landingPageInfo:landingPageReducer,
  homeInfo: homeReducer,
  locationInfo:choiceReducer,
  favouriteInfo: favouriteReducer,
  forgotPasswordInfo: forgotPasswordReducer,
  changePasswordInfo: changepasswordReducer,
  travleInfo: choiceReducer,
  postCodeInfo:choiceReducer,
  postCodeArray:choiceReducer,
  tnc:termsConditionReducer,
  privacy_policy:privacyPolicyReducer
});
